// extracted by mini-css-extract-plugin
export default {"back":"NotFound_back__OJapD","section":"NotFound_section__R-wlz","section__code_error":"NotFound_section__code_error__MTMKr","section__image":"NotFound_section__image__k62w3"};